<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-map-marker-radius"
            inline
            title="Reports by Location Group"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="locationHeaders"
              :items="grouplist"
              :items-per-page="10"
              :search="search"
            >
              <!-- <template v-slot:[`item.depositusers`]="{ item }">
                <v-btn
                  fab
                  small
                  color="brown"
                  :to="'/ReportsGroupDepositUsers/' + item.name"
                  dark
                >
                  <v-icon dark>
                    mdi-account-multiple
                  </v-icon>
                </v-btn>
              </template> -->
              <!-- <template v-slot:[`item.pickups`]="{ item }">
                <v-btn
                  fab
                  small
                  color="purple lighten-2"
                  :to="'/reportsgrouppickups/' + item.name"
                  dark
                >
                  <v-icon dark>
                    mdi-truck
                  </v-icon>
                </v-btn>
              </template> -->
              <template
                v-if="userisadmin"
                v-slot:[`item.cit`]="{ item }"
              >
                <v-btn
                  fab
                  small
                  color="red lighten-2"
                  :to="'/reportsgroupcit/' + item.name"
                  dark
                >
                  <v-icon dark>
                    mdi-shopping
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.cashin`]="{ item }">
                <v-btn
                  fab
                  small
                  color="orange"
                  :to="'/reportsgroupcashin/' + item.name"
                  dark
                >
                  <v-icon dark>
                    mdi-calendar-multiple
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.inactive`]="{ item }">
                <v-btn
                  fab
                  small
                  color="green"
                  :to="'/reportsgroupinactive/' + item.name"
                  dark
                >
                  <v-icon dark>
                    mdi-sleep
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  export default {
    name: 'Locations',

    data () {
      return {
        search: '',
        loading: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Group Name',
            align: 'left',
            value: 'name'
          },
          {
            align: 'center',
            sortable: false,
            value: 'cit',
            text: 'CIT'
          },
          {
            align: 'center',
            sortable: false,
            value: 'cashin',
            text: 'Daily Volume'
          },
          {
            align: 'center',
            sortable: false,
            value: 'inactive',
            text: 'Inactive'
          },
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs: 0,
      }
    },
    computed: {
      userisadmin () {
        if (
          this.$store.getters.user.status === 'admin' &&
          this.loading === false
        ) {
          return true
        }
        return false
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return this.$store.getters.usergroups
      },
      getlocs () {
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          this.$log.debug(' our name is ', name)
          if (value.siteunitsprofile) {
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum,
              sitename: name
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    methods: {
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
